import _keysInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/keys";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import logger from "../../../util/logger";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent } from "../../../wayin-react";
import { wrapDisplayName } from 'react-recompose';

var removeProps = function removeProps(removeKeys) {
  return function (Component) {
    return createComponent({
      displayName: wrapDisplayName(Component, 'removeProps'),
      render: function render(props) {
        if (undefined) {
          var propKeys = _keysInstanceProperty(_).call(_, props);

          _forEachInstanceProperty(_).call(_, removeKeys, function (removeKey) {
            logger.warn("Invalid prop supplied to " + Component.displayName + ": " + removeKey, _includesInstanceProperty(_).call(_, propKeys, removeKey));
          });
        }

        var passedProps = _.omit(props, removeKeys);

        return /*#__PURE__*/React.createElement(Component, passedProps);
      }
    });
  };
};

export default removeProps;
//# sourceMappingURL=remove-props.js.map